<template>
    <div class="main-container">
        <div class="title-header" style="margin: 20px 0">
            <h1 class="title" style="text-align: center">Pacientes</h1>
        </div>
        <div class="content-container">
            <EasyDataTable
                table-class-name="customize-table"
                show-index
                alternating
                :headers="headers"
                :items="items"
                :rows-per-page="10"
                hide-footer
                class="headers">
                <template #item-contacto="item">
                    <span
                        v-for="(telecom, index) in item.contacto"
                        :key="index">
                        <span v-if="telecom.value && telecom.value !== ''">
                            <v-icon>
                                {{
                                    telecom.type === 'Correo'
                                        ? 'mdi-email'
                                        : 'mdi-phone'
                                }}
                            </v-icon>
                            {{ telecom.value }}
                        </span>
                        <br />
                    </span>
                </template>

                <template #item-operation="item">
                    <v-btn
                        class="ma-2 pa-2 boton-expediente"
                        @click="seendtoExpediente(item)"
                        variant="plain">
                        Ver Expediente
                    </v-btn>
                </template>
            </EasyDataTable>
        </div>
    </div>
</template>

<script>
import EasyDataTable from 'vue3-easy-data-table';
import { getPatientsByPractitioner } from '@/api/pacientes';

export default {
    components: {
        EasyDataTable,
    },
    mounted() {
        this.practitionerId = localStorage.getItem('id-user');
        this.fetchPatientData();
    },
    methods: {
        fetchPatientData() {
            getPatientsByPractitioner(this.practitionerId)
                .then((patient) => {
                    const newItems = patient.map((item) => {
                        return {
                            id: item.id,
                            nombre: this.capitalizarPalabras(item.name.join(' ')),
                            primerApellido: this.capitalizarPalabras(item.lastName[0]),
                            segundoApellido: this.capitalizarPalabras(item.lastName[1]??''),
                            contacto: item.telecom,
                            birthdate: item.birthDate,
                        };
                    });
                    this.items = newItems;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        capitalizarPalabras(texto) {
          if (!texto) return '';
          return texto
            .split(' ')
            .map(
              palabra =>
                palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase()
            )
            .join(' ');
        },
        assignPatientId(item) {
            localStorage.setItem('patientId', item);
        },
        seendtoExpediente(item) {
            const numericId = item.id.replace(/[^0-9]+/g, '');
            this.assignPatientId(numericId);
            this.$router.push({
                params: { id: numericId },
                name: 'AuditExpediente',
            });
        },
    },
    data() {
        return {
            practitionerId: '',
            items: [],
            headers: [
                { text: 'ID', value: 'id', sortable: true },
                { text: 'Nombre(s)', value: 'nombre', sortable: true },
                {
                    text: 'Primer Apellido',
                    value: 'primerApellido',
                    sortable: true,
                },
                {
                    text: 'Segundo Apellido',
                    value: 'segundoApellido',
                    sortable: true,
                },
                { text: 'Fecha de nacimiento', value: 'birthdate' },
                { text: 'Contacto', value: 'contacto' },
                { text: 'Acciones', value: 'operation' },
            ],
        };
    },
};
</script>

<style></style>
